import { useSelector } from 'react-redux';

import { RootState } from '@/utils/store';

const useUser = () => {
  return useSelector((rootState: RootState) => rootState.auth.user);
};

export default useUser;
